import { root } from './minute-count';

export const minuteCount = {
  ...root,
};
